import {anyImageOpResult} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {z} from "zod"

export const BorderDirection = z.union([z.literal("horizontal"), z.literal("vertical")])

export const definition = {
    validation: {
        returns: z.object({
            lowBorder: anyImageOpResult,
            highBorder: anyImageOpResult,
        }),
        parameters: z.object({
            mappedImage: anyImageOpResult,
            borderBlendDistance: z.number().min(1),
            borderDirection: BorderDirection,
        }),
    },
}
